const options = {
  5: "bg-slate-50/5",
  10: "bg-slate-50/10",
  25: "bg-slate-50/25",
  50: "bg-slate-50/50",
  75: "bg-slate-50/75",
  90: "bg-slate-50/90",
  100: "bg-slate-50",
};

const from = {
  5: "from-slate-50/5",
  10: "from-slate-50/10",
  25: "from-slate-50/25",
  50: "from-slate-50/50",
  75: "from-slate-50/75",
  90: "from-slate-50/90",
  100: "from-slate-50",
};

export default function getBackgroundSlate50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
